<template>
    <PopoverRight ref="popoverMenu" width="800px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">文章生成明细</h1>
            <div class="cnt-area">
                <el-table
                    :data="recordList"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="站点" prop="site_name"  align="center" width="100"></el-table-column>
                <el-table-column  label="状态" prop="status_full" align="center"></el-table-column>
                <el-table-column  label="执行时间" prop="execute_time_full" width="300"  align="center"></el-table-column>
               
            </el-table>
                <template v-if="recordList.length > 0">
                    <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :current-page="condition.page"
                        :total="condition.total"
                        :page-size="condition.per_page"
                        @current-change="currentChange"
                    ></el-pagination>
                </template>
            </div>
                
            <div class="form-button">
                 <el-button type="info" @click.stop.prevent="hide" >返回</el-button>
                <el-button type="info" @click.stop.prevent="goList">关闭</el-button>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import {modelRecordDetail } from '@/service/newsModel'
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "record",
        components: {
            PopoverRight
        },
        data () {
         
            return {
               condition:{
                    record_id  :'',
                    total: 0,
                    per_page: 10,
                    page: 1,
               },
                recordList:[],
            }
        },
        mounted(){
            
        },
        methods : {
            open (id) {
                this.condition.record_id  = id
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
                this.getRecordDetail();
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.recordList=[];
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            async getRecordDetail(){
                await modelRecordDetail(this.condition).then((data) => {
                    this.recordList = data.data;
                    this.condition.total = data.total;
                })
            },
            goList(){
                this.hide();
                this.$emit('hide');
            },
            currentChange(index) {
                this.condition.page = index;
                this.getRecordDetail();
            },
        },
    }
</script>

<style scoped>
    .cnt-area{
        margin-top:40px;
    }
    .list-table{
        border:1px solid #EBEEF5;
    }
    .v-modal{
        z-index: 2000!important;
    }
</style>
